import { useMemo } from "react";

import { DataDropdown } from "capitalrx-components-2.0/lib/forms";

import { getApiBaseUrl } from "@/api";
import { useCustomDataSource } from "@/api-hooks";
import { FormElementBaseProps, ProviderManagement } from "@/api/interfaces";

interface NetworkDropdownProps extends FormElementBaseProps {
  remainingNetworks?: ProviderManagement.NetworkDetails[];
  readOnly: boolean;
}

export const ProviderNetworkDropdown = ({
  name = "provider_network_id",
  remainingNetworks = [],
  label = "Network",
  required = false,
  readOnly = false,
}: NetworkDropdownProps) => {
  const apiBaseUrl = getApiBaseUrl();

  const dataSource = useCustomDataSource<ProviderManagement.ProviderNetwork>({
    url: `${apiBaseUrl}/providermanagement/network_list`,
    idProvider: (row) => row.provider_network?.id,
    options: {
      filter: {
        query_term: "",
      },
      idFilterName: "id",
      pageSize: 100,
    },
    searchLength: 0,
  });

  const filteredOptions = useMemo(() => {
    if (!dataSource.rows) return [];

    const inNetworkRows = dataSource.rows.filter((row) => row.data.provider_network?.in_network === true);
    if (remainingNetworks.length === 0) return inNetworkRows;

    return inNetworkRows.filter((row) => remainingNetworks.some((network) => network.id === row.data.provider_network.id));
  }, [dataSource.rows, remainingNetworks]);

  return (
    <DataDropdown.Field
      dataSource={{ ...dataSource, rows: filteredOptions }}
      optionLabelProvider={(row) => `${row?.provider_network?.name}`}
      label={label}
      name={name}
      searchField="query_term"
      required={required}
      readOnly={readOnly}
      tooltip={
        "This list contains networks that have not yest been configured for this provider. To edit an existing network configuration, go back to the list view and click on the given record."
      }
    />
  );
};
